import React from "react";

type BaseProps = {
  placeholderText: string;
  updatedManifest: any;
  textBlockIndex: number;
  assignNewText: (newText: string) => void;
  displayImage: (imageIndex: number) => JSX.Element;
  handleImageDivClick: (index: number) => void;
  // selectImages: () => Promise<void>,
};

const BaseFullPageGraphic: React.FC<BaseProps> = (props: any) => {
  return (
    <div className="graphic-full-container" onClick={() => props.handleImageDivClick(0)} id="0">
      <div className="graphic-full-image-container">
        <div className="img-aspect-container">
          <div className="img-aspect-container-inside">
            <div className="img-aspect-centering">{props.displayImage(0)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BaseFullPageGraphic;
